import Icon from '@ant-design/icons';
import { MouseEventHandler } from 'react';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const ThumbSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0424 12.5H6.16504V21.5H20.4283L21.8321 12.5H15.4127L16.2848 10.5H21.8344C22.9389 10.5 23.8344 11.3954 23.8344 12.5C23.8344 12.6017 23.8266 12.7032 23.8112 12.8037L22.4287 21.8037C22.2788 22.7795 21.4392 23.5 20.4519 23.5H6.16504C5.06047 23.5 4.16504 22.6046 4.16504 21.5V12.5C4.16504 11.3954 5.06047 10.5 6.16504 10.5H12.8652L12.0424 12.5Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2303 6.6886C17.0169 7.04799 17.3717 7.99762 17.0213 8.80527L16.2856 10.5H18.4859L18.8575 9.64378C19.7066 7.68734 18.7421 5.36507 16.711 4.67284C14.9305 4.06624 13.0025 5.11706 12.2395 6.87514L10.666 10.5H12.8599L14.1675 7.50214C14.5179 6.6945 15.4437 6.32946 16.2303 6.6886Z"
                    fill="#9655FF"
                />
                <path d="M10.165 14.501H8.16504V19.501H10.165V14.501Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const ThumbedSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0953 12.5234L23.4447 12.5234C24.5493 12.5234 25.4447 13.4189 25.4447 14.5234C25.4447 14.6251 25.437 14.7266 25.4215 14.8271L24.0391 23.8271C23.8892 24.803 23.0496 25.5234 22.0623 25.5234H7.77539C6.67082 25.5234 5.77539 24.628 5.77539 23.5234V14.5234C5.77539 13.4189 6.67082 12.5234 7.77539 12.5234L12.2754 12.5234L13.8488 8.89858C14.6119 7.1405 16.5399 6.08968 18.3204 6.69628C20.3515 7.38851 21.316 9.71078 20.4669 11.6672L20.0953 12.5234ZM9.77614 14.5227H11.7761L12.0733 15.8528C12.5352 17.9211 12.5382 20.0655 12.082 22.135L11.7761 23.5227H9.77614L10.0799 22.1493C10.5375 20.0801 10.536 17.9358 10.0755 15.8673L9.77614 14.5227Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const TreadSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0424 15.5H6.16504V6.5H20.4283L21.8321 15.5H15.4127L16.2848 17.5H21.8344C22.9389 17.5 23.8344 16.6046 23.8344 15.5C23.8344 15.3983 23.8266 15.2968 23.8112 15.1963L22.4287 6.19635C22.2788 5.22047 21.4392 4.5 20.4519 4.5H6.16504C5.06047 4.5 4.16504 5.39543 4.16504 6.5V15.5C4.16504 16.6046 5.06047 17.5 6.16504 17.5H12.8652L12.0424 15.5Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2293 21.3114C17.0159 20.952 17.3707 20.0024 17.0203 19.1947L16.2891 17.5H18.4849L18.8565 18.3562C19.7057 20.3127 18.7411 22.6349 16.71 23.3272C14.9296 23.9338 13.0015 22.8829 12.2385 21.1249L10.665 17.5H12.8667L14.1665 20.4979C14.5169 21.3055 15.4427 21.6705 16.2293 21.3114Z"
                    fill="#9655FF"
                />
                <path d="M10.165 13.499H8.16504V8.49902H10.165V13.499Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const TreadedSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0953 17.9961L23.4447 17.9961C24.5493 17.9961 25.4447 17.1007 25.4447 15.9961C25.4447 15.8944 25.437 15.7929 25.4215 15.6924L24.0391 6.69244C23.8892 5.71657 23.0496 4.99609 22.0623 4.99609H7.77539C6.67082 4.99609 5.77539 5.89153 5.77539 6.99609V15.9961C5.77539 17.1007 6.67082 17.9961 7.77539 17.9961L12.2754 17.9961L13.8488 21.621C14.6119 23.379 16.5399 24.4299 18.3204 23.8232C20.3515 23.131 21.316 20.8087 20.4669 18.8523L20.0953 17.9961ZM9.77614 15.9968H11.7761L12.0733 14.6667C12.5352 12.5984 12.5382 10.454 12.082 8.38449L11.7761 6.99685H9.77614L10.0799 8.37025C10.5375 10.4394 10.536 12.5837 10.0755 14.6523L9.77614 15.9968Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const FeedbackSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5588 3.84961C16.4677 3.84961 17.3225 4.20368 17.9651 4.84608L20.2035 7.08472C20.8463 7.72711 21.2004 8.58191 21.2004 9.49099C21.2004 10.4001 20.8463 11.2547 20.2035 11.8973L12.1509 19.9505L4.40039 20.6496L5.09924 12.8996L13.1525 4.84629C13.7949 4.20368 14.6499 3.84961 15.5588 3.84961ZM6.68296 15.275L6.37629 18.6737L9.77503 18.367L6.68296 15.275ZM14.292 6.52216L7.64852 13.1658L11.884 17.4015L18.5276 10.7578C19.1274 10.1581 19.1274 9.18192 18.5276 8.58217L16.4676 6.52216C15.8679 5.92241 14.8917 5.92241 14.292 6.52216Z"
                    fill="#9655FF"
                />
                <path d="M23.6004 22.1494H4.40039V24.1494H23.6004V22.1494Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const CopySvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 9.00977H11V7.00977C11 5.9052 11.8954 5.00977 13 5.00977H23C24.1046 5.00977 25 5.9052 25 7.00977V17.0098C25 18.1143 24.1046 19.0098 23 19.0098H21V17.0098H23V7.00977H13V9.00977Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 11.0098C18.1046 11.0098 19 11.9052 19 13.0098V23.0098C19 24.1143 18.1046 25.0098 17 25.0098H7C5.89543 25.0098 5 24.1143 5 23.0098V13.0098C5 11.9052 5.89543 11.0098 7 11.0098H17ZM17 13.0098H7V23.0098H17V13.0098Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);
